export default class VideoControls {
  constructor(context, parent) {
    this.element = context;
    this.parent = parent;
    this.init();
  }

  init() {
    const { element, parent } = this;

    parent.querySelectorAll('video').forEach((video) => {
      if (video.hasAttribute('autoplay')) {
        this.playVideo();
      }
    });
    element?.addEventListener('click', (e) => {
      e.stopImmediatePropagation();
      element.classList.contains('video-controls--paused')
        ? this.playVideo()
        : this.pauseVideo();
    });
  }
  playVideo() {
    const { parent, element } = this;
    element.classList.remove('video-controls--paused');
    element.setAttribute('aria-label', 'Pause video');
    parent.querySelectorAll('video').forEach((video) => {
      video.play();
    });
  }
  pauseVideo() {
    const { parent, element } = this;
    element.classList.add('video-controls--paused');
    element.setAttribute('aria-label', 'Play video');
    parent.querySelectorAll('video').forEach((video) => {
      video.pause();
    });
  }
}
